<template>
  <v-container fluid>
    <v-tabs>
      <template v-for="(menu, index) in menus" :key="index">
        <v-tab
          :to="{ name: menu.route }"
        >
          {{ menu.label }}
        </v-tab>
      </template>
    </v-tabs>
    <v-card class="mt-10 transparent">
      <router-view />
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    menus() {
      let menuList = [
        {
          label: 'Lead',
          icon: 'mdi-account-group',
          route: 'compliance-lead',
        },
        {
          label: 'FinCen',
          icon: 'mdi-account-group',
          route: 'fincen-batches',
        },
        {
          label: 'OFAC Monitoring',
          icon: 'mdi-account-group',
          route: 'ofac-matches',
        },
        {
          label: 'NOAA',
          icon: 'mdi-account-group',
          route: 'compliance-noaa',
        },
      ];

      if (!this.hasPermission('view compliance::noaa')) {
        menuList = menuList.filter((menu) => menu.label !== 'NOAA');
      }

      return menuList;
    },
  },

};
</script>

<style></style>
